import * as React from "react";

const SafetyAndSecurityIcon = () => {
    return (
        <svg
            id="Group_2507"
            data-name="Group 2507"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            height="75"
            viewBox="0 0 109.401 105.153"
        >
            <defs>
                <clipPath id="clip-path">
                    <rect id="Rectangle_4852" data-name="Rectangle 4852" width="109.401" height="105.153" fill="#fff" />
                </clipPath>
            </defs>
            <g id="Group_2506" data-name="Group 2506" clipPath="url(#clip-path)">
                <path
                    id="Path_4568"
                    data-name="Path 4568"
                    d="M100.763,53.993l-.219-.1-.028-.242C98.189,32.821,85.162,15.83,67.27,10.141c.7,13.817,4.312,64.769,4.469,66.966l.032.451-2.417.173-.046-.644c-.764-10.795-4.581-64.905-4.581-70.034C64.727,2.207,59.643,0,54.92,0s-9.809,2.207-9.809,7.053c0,5.561-4.55,69.594-4.6,70.239l-.032.439-2.417-.173.032-.438c.037-.513,3.781-53.291,4.476-67.111C24.7,15.475,11.53,32.246,8.962,52.951l-.03.245-.225.1C2.848,55.953,0,59.605,0,64.466,0,86.9,24.538,105.153,54.7,105.153S109.4,86.9,109.4,64.466c0-4.192-2.907-7.715-8.638-10.473"
                    fill="#fff"
                />
            </g>
        </svg>
    );
};

export default React.memo(SafetyAndSecurityIcon);
